import React from 'react';

import PageReloadAlertModal from 'components/modal/PageReloadAlertModal.component';

const PageReloadWatcher = ({ tag, dismissable }) => (
    <div data-bem="PageReloadWatcher">
      <PageReloadAlertModal tag={tag} dismissable={dismissable ?? true} />
    </div>
  );

// noinspection JSUnusedGlobalSymbols
export default PageReloadWatcher;
